import(/* webpackMode: "eager" */ "/home/runner/_work/core/core/node_modules/next/dist/client/image-component.js");
